// extracted by mini-css-extract-plugin
export var actionButton = "_ax-1";
export var actionButtons = "_ax-2";
export var actions = "_ax-0";
export var aiUnread = "_ax-10";
export var alignCenter = "_ax-h";
export var backWrapper = "_ax-3";
export var cellContainer = "_ax-4";
export var checkboxContainer = "_ax-5";
export var contentContainer = "_ax-6";
export var contentHeader = "_ax-8";
export var conversationsTableWrapper = "_ax-s";
export var draftReplyBadgeContainer = "_ax-m";
export var dropdownItem = "_ax-b";
export var dropdownItemsContainer = "_ax-a";
export var dropdownTitle = "_ax-c";
export var errorIcon = "_ax-7";
export var filter = "_ax-d";
export var gray = "_ax-i";
export var headerActionButtons = "_ax-e";
export var headerCheckboxContainer = "_ax-f";
export var icon = "_ax-j";
export var menuContainer = "_ax-k";
export var noMoreTicketsIcon = "_ax-12";
export var noMoreTicketsSubText = "_ax-13";
export var oneLine = "_ax-l";
export var optionsButton = "_ax-n";
export var plus = "_ax-o";
export var portalButtonsWrapper = "_ax-g";
export var red = "_ax-p";
export var scrolledTop = "_ax-9";
export var search = "_ax-q";
export var selectedConversationsCount = "_ax-r";
export var spinner = "_ax-t";
export var strong = "_ax-u";
export var summaryCell = "_ax-v";
export var tableContainer = "_ax-11";
export var tagContainer = "_ax-w";
export var threeDots = "_ax-x";
export var twoLines = "_ax-y";
export var unread = "_ax-z";